import React, { useContext, useEffect, useState } from "react"
import * as s from "./index.module.less"
import { SpaceProfileContext } from "../../context"
import OnDemandOptions from "./Options"
import { TeamSizeList } from "../../../SearchParams/formField"
import { format, isSameDay } from "date-fns"
import OndPicker from "./OndPicker"

const InlineBookTour = ({}) => {
  const {
    commonData: {
      onDemandStep,
      contextDate,
      contextEndDate,
      startTime,
      endTime,
      teamSize,
      isDaily,
      holidays = [],
      optionPrice,
    },
    actions: { setValue },
  } = useContext(SpaceProfileContext)

  const [displayDateAndTime, setDisplayDateAndTime] = useState("")

  const clearFilters = () => {
    if (typeof window !== "undefined" && window.innerWidth >= 1200) {
      setValue({ onDemandStep: 0 })
    }
  }

  useEffect(() => {
    window.addEventListener("click", clearFilters)
    return () => {
      window.removeEventListener("click", clearFilters)
    }
  }, [])

  useEffect(() => {
    if (!contextDate) {
      setDisplayDateAndTime("")
      return
    }
    if (isDaily) {
      if (contextEndDate && !isSameDay(contextDate, contextEndDate)) {
        setDisplayDateAndTime(
          `${format(contextDate, "MMMM d")} - ${format(
            contextEndDate,
            "MMMM d"
          )}`
        )
      } else {
        setDisplayDateAndTime(format(contextDate, "MMMM d"))
      }
    } else {
      if (contextDate && !startTime) {
        setDisplayDateAndTime(format(contextDate, "MMMM d"))
      } else if (contextDate && startTime && endTime) {
        setDisplayDateAndTime(
          `${format(contextDate, "MMMM d")} ${format(
            startTime,
            "hh:mm a"
          )} - ${format(endTime, "hh:mm a")}`
        )
      }
    }
  }, [contextDate, isDaily, contextEndDate, startTime, endTime])

  useEffect(() => {
    resetOptions()
  }, [contextDate, startTime, teamSize])

  const resetOptions = () => {
    setValue({
      optionTotal: 0,
      optionValue: 0,
      optionPrice: 0,
      optionHstValue: 0,
      optionId: "",
      optionData: {},
      filteredOptions: [],
      days: 1,
    })
  }

  return (
    <>
      <div
        className={s.inner}
        id={"on_demand_reservation"}
        name={"on_demand_reservation"}
      >
        <h4 className={"mt-0"}>
          {optionPrice
            ? `$${optionPrice}/${isDaily ? "day" : "hour"}`
            : "Search for prices"}
        </h4>
        <ul className={s.list}>
          <li>
            <button
              className={"btn"}
              onClick={(e) => {
                e.stopPropagation()
                setValue({ onDemandStep: 1 })
              }}
            >
              <span>Date</span>
              <span>{displayDateAndTime || "Please select"}</span>
            </button>
            {onDemandStep === 1 && (
              <StepWrapper>
                <OndPicker />
              </StepWrapper>
            )}
          </li>
          <li>
            <button
              className={"btn"}
              onClick={(e) => {
                e.stopPropagation()
                setValue({ onDemandStep: 2 })
              }}
            >
              {!teamSize
                ? "Add seat count"
                : `${teamSize} ${teamSize === 1 ? "person" : "people"}`}
            </button>
            {onDemandStep === 2 && (
              <StepWrapper>
                <div
                  className={`form-group team-size-selector position-relative show`}
                  style={{ border: "none", marginBottom: "-10px" }}
                  onClick={(e) => e.stopPropagation()}
                >
                  <TeamSizeList
                    updateTeamSize={(teamSize) => {
                      setValue({ teamSize })
                      clearFilters(0)
                    }}
                    value={teamSize}
                  />
                </div>
              </StepWrapper>
            )}
          </li>
        </ul>

        <OnDemandOptions />
      </div>
    </>
  )
}

export default InlineBookTour

const StepWrapper = ({ children }) => {
  return (
    <div className={s.step_wrapper} onClick={(e) => e.stopPropagation()}>
      {children}
    </div>
  )
}

const TeamSize = () => {
  const updateTeamSize = () => {
    return null
  }
  return (
    <div className={`team-size-selector show ${s.position_fix}`}>
      <TeamSizeList updateTeamSize={updateTeamSize} value={0} />
    </div>
  )
}
